import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/index",
      name: "index",
      component: () =>
        import("./views/Index.vue")
    },
    {
      path: "/test",
      component: () =>
        import("./views/Test.vue"),
      children: [
        {
          path: "/",
          name: "one",
          component: () =>
            import("./views/test/One")
        },
        {
          path: "/test/two",
          name: "two",
          component: () =>
            import("./views/test/Two")
        },
        {
          path: "/test/three",
          name: "three",
          component: () =>
            import("./views/test/Three")
        },
        {
          path: "/test/four",
          name: "four",
          component: () =>
            import("./views/test/Four")
        },
      ]
    },
    {
      path: "/upload",
      name: "upload",
      component: () =>
        import("./views/Upload.vue")
    },
    {
      path: "/result",
      name: "result",
      component: () =>
        import("./views/Result.vue")
    },
    {
      path: "/testResult",
      name: "testResult",
      component: () =>
        import("./views/TestResult.vue")
    },
    {
      path: "/begin",
      name: "begin",
      component: () =>
        import("./views/Begin.vue")
    },
  ]
});
